const V2Day3Part1StartingDialog = {
  startDialogId: 'op1',
  nodes: {
    op1: {
      id: 'op1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.png',
      nextDialogId : "op2",
      sfx : "doorKnock"
    },
    op2: {
      id: 'op1',
      speaker: 'Nenek',
      text: `Yan!`,
      characterImage: '/assets/character/v2/nenek.png',
      backgroundImage: '/assets/backdrop/kamar_yan.png',
      nextDialogId : "op3",
      sfx : "doorKnock"
    },
    op3: {
      id: 'op1',
      speaker: 'Nenek',
      text: `Sudah saatnya bangun!`,
      characterImage: '/assets/character/v2/nenek.png',
      backgroundImage: '/assets/backdrop/kamar_yan.png',
      nextDialogId : "op4"
    },
    op4: {
      id: 'op1',
      speaker: 'Elsa',
      text: `Yan, ayo kita pergi.`,
      characterImage: '/assets/character/v2/elsa.png',
      backgroundImage: '/assets/backdrop/kamar_yan.png',
      nextDialogId : "op5"
    },
    op5: {
      id: 'op1',
      speaker: 'Nenek',
      text: `Selamat tinggal Yan`,
      characterImage: '/assets/character/v2/nenek.png',
      backgroundImage: '/assets/backdrop/kamar_yan.png',
      nextDialogId : "op2",
      isEnd : true,
    },
  },
}

export default V2Day3Part1StartingDialog